import React, { useState, useEffect, useRef } from "react";
import Loader from "../../shared/loader/loader";
import { Link, useNavigate } from "react-router";
import { toast } from "react-toastify";
import Select from "react-select";
import {
  getCannedTestTypes,
  importFile,
  getCannedTest,
} from "../../../api/cannedTests.service";
import { UploadIcon, DownloadIcon } from "../../../assets/icons/index";
import constant from "../../../utils/constant";
import CannedTestModel from "../../../model/cannedTests/cannedTest";
import importQuestionResultModal from "../../../model/cannedTests/importQuestionResult";
import { connect } from "react-redux";
import Breadcrumb from "../../shared/common/breadcrumb";
import { IBreadcrumb } from "../../../model/interface/breadcrumb";
import ExportToCSV from "../../shared/common/exportToCsv";
import { useNumericParam } from "../../../utils/useNumericParam";
import {
  buildDiagnosticTestName,
  isDiagnosticTestType,
} from "./cannedTestHelpers";

const CannedTestImport: React.FC = (props: any) => {
  const initialState = {
    gradeId: 0,
    stateId: 0,
    cannedTestTypeId: 0,
    subjectId: 0,
    cannedTestId: 0,
  };
  const defaultData: CannedTestModel = {
    cannedTestId: 0,
    stateIds: [],
    cannedTestTypeId: 0,
    gradeIds: [],
    subjectId: 0,
    testQuestions: [],
    userId: props.profile?.userId,
    sections: [],
  };

  const [grade, setGrade] = useState<any>([]);
  const [state, setState] = useState<any>([]);
  const [subject, setSubject] = useState<any>([]);
  const [cannedTestType, setCannedTestType] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);
  useState<boolean>(false);
  const [isNew, setIsNew] = useState(true);
  const [cannedTest, setCannedTest] = useState(defaultData);
  const [selectedFile, setSelectedFile] = useState<any>();
  const [questionResult, setQuestionResult] = useState<
    Array<importQuestionResultModal>
  >([]);
  const [filterInput, setFilterInput] = useState<any>(initialState);
  const childRef: any = useRef(undefined);

  let LS = localStorage.getItem("autoFill");
  if (LS) LS = JSON.parse(LS);
  const parameters: any = LS;
  const [isCannedTest, setIsCannedTest] = useState<boolean>(
    parameters?.autoFillData?.cannedTestTypeId === 3 ? true : false
  );
  const [name, setName] = useState<string>(
    parameters?.autoFillData?.name || ""
  );
  const [isApproved, setIsApproved] = useState<boolean>(
    parameters?.autoFillData?.isApproved || false
  );
  const navigate = useNavigate();
  const cannedtestId = useNumericParam("cannedtestId");

  useEffect(() => {
    if (cannedtestId && cannedtestId > 0) {
      setIsNew(false);
      bindCannedTestData(cannedtestId);
    } else {
      if (parameters?.autoFillData) {
        setFilterInput(parameters.autoFillData);
      }
    }
  }, []);

  useEffect(() => {
    getStateData();
    getGradeData();
    getCannedTestTypeData();
  }, []);

  useEffect(() => {
    getSubjectData();
  }, [filterInput.gradeId]);

  const breadcrumbItems = () => {
    const items: Array<IBreadcrumb> = [
      { name: "Canned Test", url: constant.CANNEDTESTALL },
      { name: "Import", url: "" },
    ];

    return items;
  };

  const bindCannedTestData = async (cannedTestId) => {
    setLoading(true);
    let response: any = getCannedTest(cannedTestId);
    response = (await response).data;
    setLoading(false);
    if (response) {
      setCannedTest(response);
      filterInput.stateId = response.stateId;
      filterInput.gradeId = response.gradeId;
      filterInput.subjectId = response.subjectId;
      filterInput.cannedTestTypeId = response.cannedTestTypeId;
      filterInput.cannedTestId = response.cannedTestId;
      const cannedTestTypeId = parseInt(response.cannedTestTypeId);
      // PLP-6459: keep the stored name for every type; the import saves whatever name it posts
      setName(response.name ?? "");
      if (cannedTestTypeId === 3 || cannedTestTypeId === 4) {
        setIsCannedTest(true);
        setIsApproved(response.isApproved);
      }
    } else {
      setCannedTest(defaultData);
    }
  };

  const getStateData = async () => {
    setLoading(true);
    const service = await import("../../../api/state.service");
    const response = service.getStateAll();
    const data = (await response).data;
    let newStateData = [];
    if (data.data.length > 0) {
      newStateData = data.data.map((eachStateData) => {
        return {
          value: eachStateData.stateId || 0,
          label: `${eachStateData.name}`,
        };
      });
    }
    setState(newStateData);
    setLoading(false);
  };

  const getGradeData = async () => {
    setLoading(true);
    const service = await import("../../../api/grade.service");
    const response = service.getAllgrade(100, 1);
    const data = (await response).data;
    let newGradeData = [];
    if (data.data.length > 0) {
      data.data.sort(
        (firstItem, secondItem) => firstItem.gradeId - secondItem.gradeId
      );
      newGradeData = data.data.map((eachGradeData) => {
        return {
          value: eachGradeData.gradeId || 0,
          label: `${eachGradeData.name}`,
        };
      });
    }
    setGrade(newGradeData);
    setLoading(false);
  };

  const getSubjectData = async () => {
    setLoading(true);
    const service = await import("../../../api/subject.service");
    const response = service.getSubjectByGrade(100, 1, filterInput.gradeId);
    const data = (await response).data;
    let newSubjectData = [];
    if (data.data.length > 0) {
      newSubjectData = data.data.map((eachSubjectData) => {
        return {
          value: eachSubjectData.subjectId || 0,
          label: `${eachSubjectData.name}`,
        };
      });
    }
    setSubject(newSubjectData);
    setLoading(false);
  };

  const getCannedTestTypeData = async () => {
    const response = getCannedTestTypes();
    const data = (await response).data;
    let newTestTypeData = [];
    if (data.length > 0) {
      newTestTypeData = data.map((eachTestTypeData) => {
        return {
          value: eachTestTypeData.id || 0,
          label: `${eachTestTypeData.name}`,
        };
      });
    }
    setCannedTestType(newTestTypeData);
  };

  // PLP-6459: a new diagnostic import always gets the name the Assessment Bank shows, read-only.
  // An import into an existing test keeps its stored name.
  const isDiagnostic = isDiagnosticTestType(filterInput.cannedTestTypeId);
  const diagnosticName =
    isNew && isDiagnostic
      ? buildDiagnosticTestName(
          filterInput.subjectName,
          filterInput.cannedTestTypeName
        )
      : undefined;
  const shownName = diagnosticName ?? name;

  const updateDropdownValues = (updateObj) => {
    if (updateObj.type == "State") {
      setFilterInput({
        ...filterInput,
        stateId: updateObj.value || 0,
        stateName: updateObj.label || 0,
      });
    } else if (updateObj.type == "Grade") {
      setFilterInput({
        ...filterInput,
        gradeId: updateObj.value || 0,
        gradeName: updateObj.label || 0,
      });
    } else if (updateObj.type == "CannedTestType") {
      setFilterInput({
        ...filterInput,
        cannedTestTypeId: updateObj.value || 0,
        cannedTestTypeName: updateObj.label || 0,
      });
      const cannedTestTypeId = parseInt(updateObj.value);
      setIsCannedTest(cannedTestTypeId === 3 || cannedTestTypeId === 4);
    } else if (updateObj.type == "Subject") {
      setFilterInput({
        ...filterInput,
        subjectId: updateObj.value || 0,
        subjectName: updateObj.label || 0,
      });
    }
  };

  const onFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const onFileUpload = async () => {
    if (
      filterInput.stateId == 0 ||
      filterInput.gradeId == 0 ||
      filterInput.cannedTestTypeId == 0 ||
      filterInput.subjectId == 0
    ) {
      toast.warning("Please select filters");
    } else if (selectedFile === undefined) {
      toast.warning("Please select file to import");
    } else {
      const formData = new FormData();
      formData.append("importFile", selectedFile);
      formData.append("stateId", filterInput.stateId);
      formData.append("gradeId", filterInput.gradeId);
      formData.append("subjectId", filterInput.subjectId);
      formData.append("CannedTestTypeId", filterInput.cannedTestTypeId);
      formData.append("userId", props.profile?.userId || 1);
      formData.append("name", shownName);
      formData.append("isApproved", isApproved.toString());

      if (cannedtestId) {
        formData.append("CannedTestId", cannedtestId?.toString());
      } else {
        formData.append("CannedTestId", "0");
      }

      const response = (await importFile(formData)).data;

      if (
        response &&
        response.length &&
        response.map((ds) => ds.isSuccess).includes(true)
      ) {
        toast.success("File imported successfully");
        navigate("/canned-tests");
      } else {
        toast.warning("File import failed");
      }

      setQuestionResult(response);
    }
  };

  useEffect(() => {
    window.addEventListener("beforeunload", handleTabClosing);
    window.addEventListener("unload", handleTabClosing);

    return () => {
      window.removeEventListener("beforeunload", handleTabClosing);
      window.removeEventListener("unload", handleTabClosing);
      handleTabClosing();
    };
  }, []);

  const handleTabClosing = () => {
    localStorage.removeItem("autoFill");
  };

  const exportFn = async () => {
    childRef?.current?.onDownload(
      [{ QuestionId: 2000002, RecommendedStandardId: 143616, OrderNumber: 1 }],
      "Sample canned test.csv"
    );
  };

  const handleNameChange = (e) => {
    const name: string = e.target.value;
    setName(name);
    setCannedTest({
      ...cannedTest,
      name: name,
    });
  };

  function handleIsApproved(e: any) {
    setIsApproved(e.target.checked);
    setCannedTest({
      ...cannedTest,
      isApproved: e.target.checked,
    });
  }

  return (
    <>
      {loading && <Loader />}

      <div className="flex-1 overflow-auto">
        <div className=" h-auto min-h-half w-full rounded-bl-3xl bg-site-teal px-8  py-8 pt-0 pb-14 mt-7 ">
          <div className="relative  py-1">
            <div className="overlay-image-main pointer-events-none fixed left-0 top-0 w-screen h-screen z-20"></div>
            <div className="flex items-center justify-between">
              <h3 className="text-lg font-light text-gray-900">Canned Tests</h3>
            </div>
            <Breadcrumb items={breadcrumbItems()} />
            <div className="grid grid-cols-7 text-sm justify-between">
              <div className="col-span-2 shadow py-6 border rounded-lg px-4">
                {(isCannedTest || isDiagnostic) && (
                  <div className="grid grid-cols-1">
                    <div className="text-sm w-full mt-1">
                      <div className="text-sm">
                        <label className="font-medium text-gray-700">
                          Name
                        </label>
                      </div>
                      <input
                        id=""
                        name=""
                        value={shownName}
                        onChange={(e) => handleNameChange(e)}
                        readOnly={isDiagnostic}
                        type="text"
                        className={`block w-full ${
                          isDiagnostic ? "bg-gray-100" : ""
                        } border border-gray-300 text-gray-700 rounded-md shadow-sm py-2 focus:outline-none focus:ring-primary-color focus:border-primary-color sm:text-sm`}
                        disabled={!isNew}
                      />
                    </div>
                  </div>
                )}

                <div className="grid grid-cols-1">
                  <div className="text-sm w-full mt-5">
                    <div className="text-sm ">
                      <label className="font-medium text-gray-700">State</label>
                    </div>
                    {isNew && (
                      <Select
                        value={{
                          label: filterInput.stateName,
                          value: filterInput.stateId,
                        }}
                        onChange={(result) =>
                          updateDropdownValues({
                            ...result,
                            type: "State",
                          })
                        }
                        options={state}
                        theme={(theme) => ({
                          ...theme,
                          colors: {
                            ...theme.colors,
                            primary25: "#B3B3B3",
                            primary: "#041E42",
                          },
                        })}
                      />
                    )}

                    {!isNew && (
                      <input
                        id="state"
                        name="state"
                        value={
                          state.filter(
                            (s) =>
                              s.value == (cannedTest.stateIds ?? 0).toString()
                          )[0]?.label
                        }
                        type="text"
                        className="mt-1 block w-full bg-gray-100 border border-gray-300 text-gray-700 rounded-md shadow-sm py-2 focus:outline-none focus:ring-primary-color focus:border-primary-color sm:text-sm"
                        disabled
                      />
                    )}
                  </div>
                </div>
                <div className="grid-cols-1 mt-5">
                  <div className="text-sm">
                    <label className="font-medium text-gray-700">Grade</label>
                  </div>
                  <div className="text-sm mt-1">
                    {isNew && (
                      <Select
                        value={{
                          label: filterInput.gradeName,
                          value: filterInput.gradeId,
                        }}
                        onChange={(result) =>
                          updateDropdownValues({
                            ...result,
                            type: "Grade",
                          })
                        }
                        options={grade}
                        theme={(theme) => ({
                          ...theme,
                          colors: {
                            ...theme.colors,
                            primary25: "#B3B3B3",
                            primary: "#041E42",
                          },
                        })}
                      />
                    )}
                    {!isNew && (
                      <input
                        id="grade"
                        name="grade"
                        value={
                          grade.filter(
                            (g) =>
                              g.value == (cannedTest.gradeIds ?? 0).toString()
                          )[0]?.label
                        }
                        type="text"
                        className="mt-1 block w-full bg-gray-100 border border-gray-300 text-gray-700 rounded-md shadow-sm py-2 focus:outline-none focus:ring-primary-color focus:border-primary-color sm:text-sm"
                        disabled
                      />
                    )}
                  </div>
                </div>
                <div className="grid-cols-1 mt-5">
                  <div className="text-sm">
                    <label className="font-medium text-gray-700">Subject</label>
                  </div>
                  <div className="text-sm mt-1">
                    {isNew && (
                      <Select
                        value={{
                          label: filterInput.subjectName,
                          value: filterInput.subjectId,
                        }}
                        onChange={(result) =>
                          updateDropdownValues({
                            ...result,
                            type: "Subject",
                          })
                        }
                        options={subject}
                        theme={(theme) => ({
                          ...theme,
                          colors: {
                            ...theme.colors,
                            primary25: "#B3B3B3",
                            primary: "#041E42",
                          },
                        })}
                      />
                    )}
                    {!isNew && (
                      <input
                        id="subject"
                        name="subject"
                        value={
                          subject.filter(
                            (s) => s.value == cannedTest.subjectId.toString()
                          )[0]?.label
                        }
                        type="text"
                        className="mt-1 block w-full bg-gray-100 border border-gray-300 text-gray-700 rounded-md shadow-sm py-2 focus:outline-none focus:ring-primary-color focus:border-primary-color sm:text-sm"
                        disabled
                      />
                    )}
                  </div>
                </div>

                <div className="grid-cols-1 mt-5">
                  <div className="text-sm">
                    <label className="font-medium text-gray-700">
                      Canned Test Type
                    </label>
                  </div>
                  <div className="text-sm mt-1">
                    {isNew && (
                      <Select
                        value={{
                          label: filterInput.cannedTestTypeName,
                          value: filterInput.cannedTestTypeId,
                        }}
                        onChange={(result) =>
                          updateDropdownValues({
                            ...result,
                            type: "CannedTestType",
                          })
                        }
                        options={cannedTestType}
                        theme={(theme) => ({
                          ...theme,
                          colors: {
                            ...theme.colors,
                            primary25: "#B3B3B3",
                            primary: "#041E42",
                          },
                        })}
                      />
                    )}
                    {!isNew && (
                      <input
                        id="cannedTestType"
                        name="cannedTestType"
                        value={
                          cannedTestType.filter(
                            (t) =>
                              t.value == cannedTest.cannedTestTypeId.toString()
                          )[0]?.label
                        }
                        type="text"
                        className="mt-1 block w-full bg-gray-100 border border-gray-300 text-gray-700 rounded-md shadow-sm py-2 focus:outline-none focus:ring-primary-color focus:border-primary-color sm:text-sm"
                        disabled
                      />
                    )}
                  </div>
                </div>
                <div className="flex flex-row items-center mt-5">
                  <div>
                    <input
                      id="isApproved"
                      type="checkbox"
                      checked={isApproved}
                      onChange={handleIsApproved}
                      className="focus:ring-primary-color mr-2 h-4 w-4 text-primary-color border-gray-300 rounded"
                    />
                  </div>
                  <div className=" text-sm ">
                    <label className="font-medium text-gray-700">
                      Approved
                    </label>
                  </div>
                </div>
                <div className="flex justify-between items-center mt-5">
                  <div className="border p-2 bg-gray-50 cursor-pointer group w-full">
                    <label className="relative cursor-pointer rounded-lg font-medium ">
                      <div className="flex justify-center items-center">
                        <UploadIcon className="w-6 text-gray-500 group-hover:text-blue-500 "></UploadIcon>
                        <span className="text-blue-700 group-hover:text-blue-500 ml-2">
                          Upload a file
                        </span>
                      </div>
                      <input
                        type="file"
                        onChange={onFileChange}
                        name="importFile"
                        className="sr-only"
                      />
                    </label>
                  </div>
                </div>
                <div className="flex justify-end items-center mt-5">
                  <button
                    type="button"
                    onClick={onFileUpload}
                    className="inline-flex items-center text-sm text-white dark:text-white gap-2 bg-primary-color hover:bg-secondary-color py-1.5 px-4 rounded-lg mr-1"
                  >
                    <span>Import</span>
                  </button>
                  <Link
                    type="button"
                    to={`${"/canned-tests/edit/" + cannedtestId}`}
                    className="inline-flex items-center px-3 py-2 my-3 text-sm font-medium leading-4 text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color"
                  >
                    <span>Cancel</span>
                  </Link>
                </div>
                <div className="mt-4">
                  <a className="cursor-pointer flex" onClick={() => exportFn()}>
                    <DownloadIcon className="w-4 text-gray-500 group-hover:text-blue-500 mr-1"></DownloadIcon>
                    Sample file
                  </a>
                  <ExportToCSV ref={childRef} />
                </div>
              </div>
              {questionResult.length > 0 && (
                <div className="col-span-5 ml-14">
                  <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                    <table className="min-w-full divide-y divide-gray-200">
                      <thead className="bg-primary-color">
                        <tr>
                          <th
                            scope="col"
                            className="px-3 py-2 pl-6 font-light text-sm text-left text-white dark:text-white tracking-wider"
                          >
                            {" "}
                            <span className="flex">
                              <span>QuestionId</span>{" "}
                            </span>
                          </th>
                          <th
                            scope="col"
                            className="px-3 py-2 pl-6 font-light text-sm text-left text-white dark:text-white tracking-wider"
                          >
                            {" "}
                            <span className="flex">
                              <span>Message</span>{" "}
                            </span>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {questionResult.map((result, index) => (
                          <tr
                            key={index}
                            className={
                              result.isSuccess ? "bg-white" : "bg-gray-100"
                            }
                          >
                            <td
                              scope="col"
                              className="px-3 py-2  pl-6 text-sm text-left font-normal text-gray-500"
                            >
                              <span>{result.questionId}</span>
                            </td>
                            <td
                              scope="col"
                              className="px-3 py-2  pl-6 text-sm text-left font-normal text-gray-500"
                            >
                              <span>{result.errorMessage}</span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
const mapStateToProps = (state: any) => {
  return {
    profile: state.profile,
  };
};
export default connect(mapStateToProps, {})(CannedTestImport);
